module.exports = __webpack_public_path__ + "static/fonts/lato-v23-latin-ext_latin-700.9e7827a.woff2";